import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import './AdminUserScreen.scss';
import UserForm from '../../components/UserForm/UserForm';
import { publicHash, SUCCESS } from '../../utils/constants';
import BalancePart from './BalancePart/BalancePart';
import Alert from '../../components/AlertForm/Alert';

class AdminUserScreen extends Component {
  static propTypes = {
    match: PropTypes.shape({}).isRequired,
    getApps: PropTypes.func.isRequired,
    apps: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    currentAppCampaigns: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    getAppCampaigns: PropTypes.func.isRequired,
    getAppCampaignsStatus: PropTypes.string.isRequired,
    getBalanceHistory: PropTypes.func.isRequired,
    hasMoreBalanceHistory: PropTypes.bool.isRequired,
    balanceHistory: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    balanceHistoryPage: PropTypes.number.isRequired,
    history: PropTypes.shape({
      push: PropTypes.func,
      location: PropTypes.shape({}),
    }).isRequired,
    resetBalanceHistory: PropTypes.func.isRequired,
    refillBalance: PropTypes.func.isRequired,
    refillBalanceStatus: PropTypes.string.isRequired,
    annulStoreErrors: PropTypes.func.isRequired,
    refillBalanceError: PropTypes.string.isRequired,
    patchUserPrivilege: PropTypes.func.isRequired,
    patchUserDemotePrivilege: PropTypes.func.isRequired,
    getAdminProfile: PropTypes.func.isRequired,
    adminProfile: PropTypes.shape({}).isRequired,
    alertPopup: PropTypes.shape({
      statusAlert: PropTypes.bool.isRequired,
      typeAlert: PropTypes.number.isRequired,
      messageAlert: PropTypes.string.isRequired,
    }).isRequired,
    setAlertStatus: PropTypes.func.isRequired,
    sidebarStatus: PropTypes.bool,
  };
  static defaultProps = {
    sidebarStatus: true,
  }
  state = {};

  componentWillMount() {
    const {
      match: {
        params: { clientId },
      },
      getAdminProfile,
    } = this.props;
    // eslint-disable-next-line no-plusplus
    // for (let i = 0; i < 2; i++) {
    getAdminProfile({ userId: clientId });
    if (this.props.adminProfile === undefined) {
      getAdminProfile({ userId: clientId });
    }
    // }
  }

  componentDidUpdate(prevProps) {
    const {
      getAdminProfile,
      refillBalanceStatus,
      match: {
        params: { clientId },
      },
    } = this.props;
    if (
      refillBalanceStatus !== prevProps.refillBalanceStatus &&
      refillBalanceStatus === SUCCESS
    ) {
      getAdminProfile({ userId: clientId });
    }
    if (this.props.adminProfile === undefined) {
      getAdminProfile({ userId: clientId });
    }
  }
  navigateBack = () => {
    this.props.history.push(`${publicHash}/app/clients`);
  };
  navigateToBalance = (id) => {
    this.props.history.push(`${publicHash}/app/client/${id}/money`);
  };
  navigateToProfile = (id) => {
    this.props.history.push(`${publicHash}/app/client/${id}/profile`);
  };
  navigateToApps = (id) => {
    this.props.history.push(`${publicHash}/app/apps/${id}`);
  };
  handleDemotePrivilege = (id) => {
    const { patchUserDemotePrivilege } = this.props;
    patchUserDemotePrivilege(id);
    const {
      match: {
        params: { clientId },
      },
      getAdminProfile,
    } = this.props;
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < 2; i++) {
      getAdminProfile({ userId: clientId });
    }
  };

  handleUpdateProfile = (id) => {
    const { patchUserPrivilege } = this.props;
    patchUserPrivilege(id);
    const {
      match: {
        params: { clientId },
      },
      getAdminProfile,
    } = this.props;
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < 2; i++) {
      getAdminProfile({ userId: clientId });
    }
  };
  render() {
    const {
      history: { location },
      getApps,
      currentAppCampaigns,
      getAppCampaigns,
      apps,
      getBalanceHistory,
      balanceHistory,
      balanceHistoryPage,
      hasMoreBalanceHistory,
      getAppCampaignsStatus,
      resetBalanceHistory,
      refillBalance,
      refillBalanceStatus,
      refillBalanceError,
      annulStoreErrors,
      adminProfile,
      alertPopup,
      setAlertStatus,
      sidebarStatus,
    } = this.props;
    const adminUserScreenClasses = classNames({
      screen: true,
      'admin-user-screen': true,
    });
    const isBilling = location.pathname.indexOf('money') > -1;
    const buttonControlClassNames = classNames({
      'main-panel-control-wrapper': true,
      'is-billing': isBilling,
    });
    const invoiceMethod = adminProfile && adminProfile.invoiceMethod
      ? { active: true, ...adminProfile.invoiceMethod }
      : {};
    const cardMethod = adminProfile && adminProfile.cardMethod
      ? { active: true, ...adminProfile.cardMethod }
      : {};
    const userSelectRole = adminProfile && adminProfile.profile.role === 'ADMIN';
    return (
      <div className={adminUserScreenClasses}>
        {alertPopup !== undefined ?
          <Alert
            type={alertPopup.typeAlert}
            message={alertPopup.messageAlert}
            status={alertPopup.statusAlert}
            setAlertStatus={setAlertStatus}
          /> : null
        }
        {adminProfile !== undefined &&
        <div className="main-panel-parameter-name">
          <span style={{ paddingRight: userSelectRole && '110px' }}>{adminProfile.profile.fullName}</span>
          <div className={buttonControlClassNames}>
            <button
              onClick={() => this.navigateToProfile(adminProfile.id)}
              className="main-panel-button"
            >
              PROFILE
            </button>
            {!userSelectRole &&
            <button
              onClick={() => this.navigateToBalance(adminProfile.id)}
              className="main-panel-button"
            >
              BILLING INFO
            </button>
            }
          </div>
        </div>
        }
        <div className="screen-content">
          <Switch location={location}>
            {adminProfile !== undefined &&
            <Route
              exact
              path={`${publicHash}/app/client/:clientId/profile`}
              render={() => (
                <UserForm
                  profile={adminProfile.profile}
                  id={adminProfile.id}
                  isAdminUserScreen
                  email={adminProfile.email}
                  patchUserDemotePrivilege={this.handleDemotePrivilege}
                  patchUserPrivilege={this.handleUpdateProfile}
                  getAdminProfile={this.props.getAdminProfile}
                  sidebarStatus={sidebarStatus}
                  navigateToApps={() => {
                    this.navigateToApps(adminProfile.id);
                  }}
                />
              )}
            />
            }
            {adminProfile !== undefined &&
              <Route
                exact
                path={`${publicHash}/app/client/:clientId/money`}
                render={() => (
                  <BalancePart
                    getApps={getApps}
                    getAppCampaigns={getAppCampaigns}
                    apps={apps}
                    currentAppCampaigns={currentAppCampaigns}
                    invoiceMethod={invoiceMethod}
                    cardMethod={cardMethod}
                    balance={adminProfile.balance}
                    getBalanceHistory={getBalanceHistory}
                    balanceHistory={balanceHistory}
                    hasMoreBalanceHistory={hasMoreBalanceHistory}
                    id={adminProfile.id}
                    balanceHistoryPage={balanceHistoryPage}
                    getAppCampaignsStatus={getAppCampaignsStatus}
                    resetBalanceHistory={resetBalanceHistory}
                    refillBalance={refillBalance}
                    refillBalanceStatus={refillBalanceStatus}
                    refillBalanceError={refillBalanceError}
                    annulStoreErrors={annulStoreErrors}
                    fullName={adminProfile.profile.fullName}
                  />
                )}
              />
            }
          </Switch>
        </div>
      </div>
    );
  }
}

export default AdminUserScreen;



// WEBPACK FOOTER //
// ./src/containers/AdminUserScreen/AdminUserScreen.js